import {
    getTeamUserList,
    addTeamUser,
    delTeamUser,
    getTeamDepartment,
    addTeamDepartment,
    updateTeamDepartment,
    delTeamDepartment,
    updateTeamUser,
    getCompanyUserList, getTeamUserListAll, getAllTeamMember,
} from "@/api/groups.js";
import {ElMessage} from "element-plus";

const emailMass = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {}

};

export default emailMass;
